module.exports = __webpack_public_path__ + "img/userTria.988f615e.png";